import {
  getErrorMessage,
  modalError,
  shouldShowErrorAsModal,
  toastError,
} from '@/shared/utils/error';
import { AxiosError } from 'axios';

function handleError(event) {
  const err = event.reason || event.error;
  console.info('*** app/handleError', getErrorMessage(err), { event });

  // Show as modal (user must click OK) for certain backend error codes; otherwise toast
  if (shouldShowErrorAsModal(err)) {
    modalError(err);
  } else {
    toastError(err);
  }
  // if is Axios or EOneRequestError
  if (err?.['config']?.['url']) {
    console.info('error.config.url=', err?.['config']?.['url']);
    return;
  }

  // keeping the legacy logic
  if (event.reason) {
    // axios error
    if (event.reason instanceof AxiosError) {
      if (event.reason.code === 'ERR_NETWORK') {
        console.log('network error');
        return;
      }
      if (event.reason.code === 'ECONNABORTED') {
        console.log('request timeout');
        return;
      }
      if (event.reason.code === 'ERR_CANCELED') {
        return;
      }
    }
    if (event.reason.message) {
      console.log(event.reason.message);
      return;
    }
  }
  if (event.error) {
    if (event.error?.message) {
      console.log(event.error.message);
      return;
    }
  }
  // unknown error
}

function initErrorHandle() {
  window.addEventListener('error', handleError);
  window.addEventListener('unhandledrejection', handleError);

  return () => {
    window.removeEventListener('error', handleError);
    window.removeEventListener('unhandledrejection', handleError);
  };
}

export { initErrorHandle };
